import { render, staticRenderFns } from "./DeleteAccountBond.vue?vue&type=template&id=31afd3d4"
import script from "./DeleteAccountBond.vue?vue&type=script&lang=js"
export * from "./DeleteAccountBond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports